import type { Opportunity } from "../data/api-types";
import { mockToday as today } from "./today";

function customerRef(id: string, name: string) {
  return { id, name, type: "customer", _self: `/customers/${id}` };
}

export const mockOpportunity: Opportunity = {
  _self: "/views/opportunities/opp_001",
  type: "opportunity",
  customer: customerRef("cust_012", "Bramley & Co"),
  id: "opp_001",
  opportunity_id: "opp_001",
  customer_id: "cust_012",
  alert_id: "alert_001",
  signal_id: "sig_001",
  opportunity_definition_id: "nbadef_followup_call",
  opportunity_family: "retention",
  opportunity_name: "Schedule a check-in call",
  title: "Call Bramley & Co about order cadence",
  rationale:
    "Customer's order cadence has dropped — proactively engage to understand why.",
  suggested_message:
    "Hi Bramley team, we noticed your usual ordering pattern has slipped recently. Is there anything we can help with?",
  suggested_action_type: "call",
  priority: "urgent",
  due_date: today,
  status: "open",
  lifecycle_status: "open",
  segment_id: "strategic",
  created_at: `${today}T09:00:00Z`,
  completed_at: null,
  converted_to_task_id: null,
};

export const mockOpportunities: Opportunity[] = [
  mockOpportunity,
  {
    _self: "/views/opportunities/opp_002",
    type: "opportunity",
    customer: customerRef("cust_048", "Business School UK"),
    id: "opp_002",
    opportunity_id: "opp_002",
    customer_id: "cust_048",
    alert_id: "alert_002",
    signal_id: "sig_003",
    opportunity_definition_id: "nbadef_expand_category",
    opportunity_family: "growth",
    opportunity_name: "Pitch packaging services",
    title: "Pitch packaging services to Business School UK",
    rationale:
      "Strong engagement and adjacent demand signal — good time to expand the relationship.",
    suggested_message:
      "We'd love to share how we've helped similar customers with packaging.",
    suggested_action_type: "email",
    priority: "recommended",
    due_date: today,
    status: "open",
    lifecycle_status: "open",
    segment_id: "strategic",
    created_at: `${today}T09:00:00Z`,
    completed_at: null,
    converted_to_task_id: null,
  },
  {
    _self: "/views/opportunities/opp_003",
    type: "opportunity",
    customer: customerRef("cust_073", "Henderson Group"),
    id: "opp_003",
    opportunity_id: "opp_003",
    customer_id: "cust_073",
    alert_id: "alert_003",
    signal_id: "sig_004",
    opportunity_definition_id: "nbadef_urgent_followup",
    opportunity_family: "retention",
    opportunity_name: "Urgent re-engagement",
    title: "Re-engage Henderson Group urgently",
    rationale:
      "27 days since last order vs ~35d normal. Risk of disengagement.",
    suggested_message:
      "Hi Henderson team, just checking in — we'd love to support your next project.",
    suggested_action_type: "call",
    priority: "urgent",
    due_date: today,
    status: "open",
    lifecycle_status: "open",
    segment_id: "client",
    created_at: `${today}T09:00:00Z`,
    completed_at: null,
    converted_to_task_id: null,
  },
];
